import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface CarouselControlsProps {
  /** Palabra del contador: "Tomo", "Receta", "Bono". */
  label: string;
  index: number;
  count: number;
  onGo: (i: number) => void;
  tone?: 'light' | 'dark';
  className?: string;
}

/** Flechas + indicadores + contador "Tomo 1 de 6". */
export function CarouselControls({
  label,
  index,
  count,
  onGo,
  tone = 'light',
  className = ''
}: CarouselControlsProps) {
  const dark = tone === 'dark';
  const arrow = dark ? 'bg-white/10 text-white hover:bg-white/20 disabled:text-white/30 disabled:hover:bg-white/10' : 'bg-white text-charcoal ring-1 ring-stone hover:bg-sand disabled:text-charcoal/30 disabled:hover:bg-white';
  const dotIdle = dark ? 'bg-white/30' : 'bg-charcoal/20';
  return <div className={`flex items-center justify-between gap-3 ${className}`} data-id="element-57" data-mp="2kp0o0rvqpl8s">
      <button type="button" onClick={() => onGo(index - 1)} disabled={index === 0} aria-label={`${label} anterior`} className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 disabled:cursor-not-allowed ${arrow}`} data-id="element-58" data-mp="2gnfg7ky2bx5g">
        <ChevronLeftIcon className="h-5 w-5" aria-hidden strokeWidth={2.5} data-id="element-59" data-mp="1ioaq6z270w33" />
      </button>

      <div className="flex min-w-0 flex-col items-center gap-1.5" data-id="element-60" data-mp="1ily7gjom2hoz">
        <p aria-live="polite" className={`font-display text-[0.68rem] font-bold uppercase tracking-[0.1em] tabular-nums ${dark ? 'text-white/80' : 'text-taupe'}`} data-id="element-61" data-mp="26eer2ynzyhqe">
          {label} {index + 1} de {count}
        </p>
        <div className="flex items-center" data-id="element-62" data-mp="21e0tybnxos75">
          {Array.from({
          length: count
        }, (_, i) => <button key={i} type="button" onClick={() => onGo(i)} aria-label={`Ir a ${label.toLowerCase()} ${i + 1}`} aria-current={i === index} className="flex h-6 items-center px-1 focus:outline-none focus-visible:rounded-full focus-visible:ring-2 focus-visible:ring-gold" data-id="element-63" data-mp="lxs7ia2mwdh1">
              <span className={`block h-2 rounded-full transition-[width,background-color] duration-200 ease-out ${i === index ? 'w-5 bg-gold' : `w-2 ${dotIdle}`}`} data-id="element-64" data-mp="2iw7oqyykk4az" />
            </button>)}
        </div>
      </div>

      <button type="button" onClick={() => onGo(index + 1)} disabled={index === count - 1} aria-label={`${label} siguiente`} className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 disabled:cursor-not-allowed ${arrow}`} data-id="element-65" data-mp="24wpwuapz8axe">
        <ChevronRightIcon className="h-5 w-5" aria-hidden strokeWidth={2.5} data-id="element-66" data-mp="3pcjq18wou2as" />
      </button>
    </div>;
}